import React, { Component } from "react";

class MessageModal extends Component {

  handleClick = () => {
    const { onClick } = this.props;
    onClick();
  }

  render() {
    const { title, subtitle, buttonClass } = this.props;

    return (
      <>
        <div   translate="no" className="notranslate modal fade show animated fadeInDown fast" id="levDadosAcesso" style={{ "display": "block" }}>
          <div   translate="no" className="notranslate modal-dialog modal-dialog-centered" role="document">
            <div   translate="no" className="notranslate modal-content">
              <div   translate="no" className="notranslate modal-header text-center align-items-center flex-column p-0">
                <h5 className="notranslate h2 modal-title" id="exampleModalLabel2">{title}</h5>
                <p   translate="no" className="notranslate mb-4 pb-2">{subtitle}</p>
                <button type="button" className="notranslate close" data-dismiss="modal" aria-label="Close" onClick={this.handleClick}>
                  <span   translate="no" aria-hidden="true">&times;</span>
                </button>
              </div>
              <div   translate="no" className="notranslate modal-body">
                <button className={`btn btn-${buttonClass} w-100`} onClick={this.handleClick}>OK</button>
              </div>
            </div>
          </div>
        </div>
        <div   translate="no" className="notranslate modal-backdrop fade show"></div>
      </>
    )
  }
}
export default MessageModal;
